import type { RouteLocationNormalized, RouteLocationRaw } from 'vue-router';

/** Rota atual da tela Identidade (spec 2026-10-15-reembolso-identidade-design.md). */
export const IDENTIDADE_PATH = '/reembolso/identidade';

/**
 * `/apis/identidade` → `/reembolso/identidade`, preservando query e hash. O caminho velho
 * continua sendo citado em pendências do ERP já gravadas e em favoritos; quem chega por ele
 * cai na tela nova, e o guard decide o acesso pela rota NOVA.
 */
export function identidadeRedirect(to: Pick<RouteLocationNormalized, 'query' | 'hash'>): RouteLocationRaw {
  return { path: IDENTIDADE_PATH, query: to.query, hash: to.hash };
}
